import {
  exchangeAgentGuidanceIdFormat,
  productFamilyIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const updateExchangeAgentGuidance = {
  name: "updateExchangeAgentGuidance" as const,
  input: z.object({
    id: exchangeAgentGuidanceIdFormat.schema,
    returnProductIds: z.array(productFamilyIdFormat.schema),
    recommendations: z.array(
      z.object({
        context: z.string(),
        productIds: z.array(productFamilyIdFormat.schema),
      }),
    ),
  }),
  output: z.object({}),
};
